import React, { useState } from "react";
import "./Nav.css";
import { useNavigate } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import { Text } from "foundation";
import { responsivePadding } from "Outlets/MainOutlet";

const menu: string = require("icons/Menu.svg").default;
const close: string = require("icons/Close.svg").default;
const links: string[] = ["Coding", "Photography", "Design", "About"];

const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState<boolean>(false);

  const handleClick = (key?: string) => {
    console.log("navigate");
    navigate(`/${key?.toLowerCase() ?? ""}`);
    setShowMenu(false);
  };

  const handleMenu = () => {
    setShowMenu((prev) => !prev);
  };

  return (
    <Flex id="page-top" padding={responsivePadding}>
      <Flex
        position="fixed"
        top="0"
        right={showMenu ? "0" : "-100%"}
        width="full"
        height="full"
        backgroundColor="black"
        color="white"
        direction="column"
        justify="center"
        align="center"
        transition="0.4s ease-in-out"
      >
        <Flex
          onClick={handleMenu}
          position="absolute"
          top={responsivePadding}
          right={responsivePadding}
          cursor="pointer"
        >
          <img src={close} alt="Close Menu" />
        </Flex>
        {links.map((link, index) => (
          <Text
            textStyle="h1"
            key={index}
            onClick={() => handleClick(link)}
            clickable
          >
            {link}
          </Text>
        ))}
      </Flex>
      <Flex justify="space-between" align="center" width="full">
        <Text textStyle="h4" onClick={() => handleClick()} clickable>
          markcwy
        </Text>
        <Flex onClick={handleMenu} cursor="pointer">
          <img src={menu} alt="Hamburger Menu" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default NavBar;
